import { render, staticRenderFns } from "./JeecgOrderModalForJEditableTable.vue?vue&type=template&id=50744003&scoped=true&"
import script from "./JeecgOrderModalForJEditableTable.vue?vue&type=script&lang=js&"
export * from "./JeecgOrderModalForJEditableTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50744003",
  null
  
)

export default component.exports